import React from "react";

type attributes = {
    city :string,
    departmentDetails:[]
}

export const DepartmentsStat = (props:attributes) => {
return (<>
    <h4>Departments in {props.city}</h4>
        <table className="table table-hover table-sm">
            <thead>
                <tr>
                    <th>Department</th>
                    <th className="text-end">Count</th>
                </tr>
            </thead>
            <tbody>
                {
                   props.departmentDetails.map((depts:any)=>{
                      if(depts.TotalCount>0){
                        return(
                            <tr>
                            <td>{depts.DepartmentName}</td>
                            <td className="text-end">{depts.TotalCount}</td>
                        </tr>
                        )
                      }
                    })
                }
                
            </tbody>
        </table>
    </>)
}